export const ADMIN = "admin";
export const RELIEF = "relief";
export const PARTICIPANT = "participant";
